/**
 * The pages that are setup surfaces (backend `setup_chat.SETUP_PAGES`): the
 * assistant opened there asks for setup help, which the backend grants or
 * not (`status.setup_chat`). Help buttons elsewhere ask with a guide topic.
 */
export const SETUP_PAGES = ['getting_started', 'setup_rock', 'setup_planning_center']

/**
 * @param {string} [page] - `pageContext.page`
 * @returns {boolean}
 */
export function isSetupPage(page) {
  return SETUP_PAGES.includes(page)
}
